import { merge } from "lodash"
import defaultConfig from "./configuration/default"

export default {
  materialType: "labour-court-decision",
  title: "label.labourCourtDecision",
  description: "description.labourCourtDecision",
  languages: ["fi"],
  configuration: merge({}, defaultConfig, {
    listing: {
      caption: true,
      title: true,
      type: true,
    },
  }),
}
